import { render, staticRenderFns } from "./CustomerWrite.vue?vue&type=template&id=09d8a15e&scoped=true&"
import script from "./CustomerWrite.vue?vue&type=script&lang=js&"
export * from "./CustomerWrite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d8a15e",
  null
  
)

export default component.exports